/**
 * @author        luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright     Copyright (c) 2022, Zumper
 */

import { Button, Checkbox, cn } from '@zcode-ui/shadz-ui'
import React from 'react'
import { MapListToggle } from '../MapListToggle'
import { Refresh as RefreshIcon } from './Refresh'

const MAP_LIVE_UPDATE_SETTING = 'mapLiveUpdateSettingCheckbox'

export interface SearchAsIMoveTheMapProps {
  isFavoritesView: boolean
  isMessagedView: boolean
  isMobile: boolean
  isPinFeatureEnabled?: boolean
  isSavedSearchesView: boolean
  onRedoSearch: () => void
  onToggleSearchAsMove: () => void
  onMapListToggleClick: () => void
  searchAsMove: boolean
  shimmer: boolean
  showRedoSearch: boolean
  viewType: string
}

export const SearchAsIMoveTheMap = ({
  isFavoritesView,
  isMessagedView,
  isMobile,
  isPinFeatureEnabled,
  isSavedSearchesView,
  onRedoSearch,
  onToggleSearchAsMove,
  onMapListToggleClick,
  searchAsMove,
  shimmer,
  showRedoSearch,
  viewType,
}: SearchAsIMoveTheMapProps) => {
  return (
    <div className="flex items-center pointer-events-none [&_*]:pointer-events-auto">
      <div className="md:hidden">
        <MapListToggle
          isPinFeatureEnabled={isPinFeatureEnabled}
          onClick={onMapListToggleClick}
          shimmer={shimmer}
          viewType={viewType}
        />
      </div>

      {!isMobile &&
        !showRedoSearch &&
        !isFavoritesView &&
        !isMessagedView &&
        !isSavedSearchesView && (
          <div
            className={cn(
              'hidden md:flex items-center justify-between px-2.5 py-[5px] text-sm text-gray-800 bg-gray-0 border border-solid border-gray-0 rounded shadow-[0_1px_6px_0_rgba(0,0,0,0.2)] select-none max-[1200px]:top-[94px] max-[1200px]:right-0',
              isPinFeatureEnabled && 'py-1.5 px-3 rounded-md shadow-[0_4px_8px_rgba(0,0,0,0.12)]'
            )}
          >
            <Checkbox
              className="w-[18px] h-[18px] border-[#cdcdd4]"
              id={MAP_LIVE_UPDATE_SETTING}
              checked={searchAsMove}
              name={MAP_LIVE_UPDATE_SETTING}
              onClick={onToggleSearchAsMove}
            >
              {isPinFeatureEnabled ? 'Refresh as I move map' : 'Search as I move the map'}
            </Checkbox>
          </div>
        )}
      {!isMobile && showRedoSearch && (
        <div
          className={cn(
            'text-sm text-gray-800 bg-gray-0 ml-2.5 rounded shadow-[0_1px_6px_0_rgba(0,0,0,0.2)] select-none max-[1200px]:top-[94px] max-[1200px]:right-0',
            isPinFeatureEnabled && 'rounded-md shadow-[0_4px_8px_rgba(0,0,0,0.12)]'
          )}
        >
          <Button
            className={cn(
              'h-8 rounded py-2.5 px-4 text-sm',
              isPinFeatureEnabled && 'bg-[#d93364] rounded-md py-0 px-5'
            )}
            variant="secondary"
            onClick={onRedoSearch}
          >
            {!isPinFeatureEnabled && <RefreshIcon />}
            <span
              className={cn(
                'pl-[5px] tracking-[-0.2px] text-sm',
                isPinFeatureEnabled && 'text-base pl-0'
              )}
            >
              Redo search in this area
            </span>
          </Button>
        </div>
      )}
    </div>
  )
}
